import { Modal } from 'antd';

let MyModal = {
	info: (title, content, callback, okDisabled=false) => {
		return Modal.info({
			title,
			content,
			okButtonProps: {
				disabled: okDisabled
			},
			onOk: ()=>{
				if (callback)
					callback()
			}
		})
	},
	success: (title, content, callback) => {
		return Modal.success({
			title,
			content,
			onOk: ()=>{
				if (callback)
					callback()
			}
		})
	},
	error: (title, content, callback) => {
		return Modal.error({
			title,
			content,
			onOk: ()=>{
				if (callback)
					callback()
			}
		})
	},
	warning: (title, content, callback) => {
		return Modal.warning({
			title,
			content,
			onOk: ()=>{
				if (callback)
					callback()
			}
		})
	},
	confirm: (title, content, callback, okText="OK", cancelText="Cancel") => {
		return Modal.confirm({
			title,
			content,
			okText,
			cancelText,
			onOk: ()=>{
				if (callback)
					callback(true)
			},
			onCancel: ()=>{
				if (callback)
					callback(false)
			}
		})
	},
	detail: (title, content, callback, okDisabled=false) => {
		return Modal.info({
			title,
			content,
			okButtonProps: {
				disabled: okDisabled
			},
			width: "70%",
			onOk: ()=>{
				if (callback)
					callback()
			}
		})
	}
}

export default MyModal


// WEBPACK FOOTER //
// ./src/containers/Modal/index.js